import { connect } from "react-redux";
import React from "react";
import './styles.css'


const HowItWorks = () => {
    return (
    <div className="documentation">
        <h3>
            Currently we only indentify the following genres: Pop, Classical, Country & Metal. Wait for more Genres to be added.
        </h3>
    </div>
)};

export default connect(
  undefined,
  undefined,
)(HowItWorks)